import { useState } from "react";
import styled from "styled-components";
import { FaPlay, FaTimes } from "react-icons/fa";
import glimpseImg from "../assets/images/glimpses.webp";

/* ---------- STYLES ---------- */

const Wrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: auto;
  position: relative;
  scroll-margin-top: 100px;
  @media (max-width: 768px) {
    scroll-margin-top: 100px;
  }
`;

const Thumbnail = styled.div`
  width: 100%;
  height: 600px;
  background: #ddd;
  background-image: url(${(p) => p.image});
  background-size: cover;
  background-position: center;
  border-radius: 14px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 350px;
  }
`;

const PlayButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 85px;
  height: 85px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 26px;
  transition: 0.3s;

  ${Thumbnail}:hover & {
    background: #d6a54f;
    transform: translate(-50%, -50%) scale(1.1);
  }
`;

const Modal = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

const PlayerBox = styled.div`
  width: 90%;
  max-width: 1000px;
  position: relative;
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 560px;
  border-radius: 10px;
  border: none;

  @media (max-width: 768px) {
    height: 300px;
  }
`;

const Close = styled.button`
  position: absolute;
  top: -45px;
  right: 0;
  background: #fff;
  border: none;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Section = styled.section`
  width: 100%;
  background: linear-gradient(135deg, #f8fbff, #eef5ff);
  padding: 10px 0;
  scroll-margin-top: 100px;

  @media (max-width: 768px) {
    padding: 10px 0;
    scroll-margin-top: 20px;
  }
`;

const Title = styled.h1`
  font-size: 38px;
  color: #791e1b;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const Description = styled.p`
  text-align: center;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    font-size: 12px;
    margin-bottom: 4px;
  }
`;

/* ---------- COMPONENT ---------- */

export default function GlimpsesVideo({
  src,
  thumbnail = glimpseImg,
  title = "video",
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Thumbnail */}
      <Section id="glimpses-of-previous-event">
        <Title>Glimpses of Previous Event</Title>
        <Description>
          A look back at powerful moments, engaging discussions, award
          celebrations, and collaborative exchanges from previous editions.
        </Description>
        <Wrapper>
          <Thumbnail image={thumbnail} onClick={() => setOpen(true)}>
            <PlayButton>
              <FaPlay />
            </PlayButton>
          </Thumbnail>
        </Wrapper>
      </Section>

      {/* Modal Player */}
      {open && (
        <Modal onClick={() => setOpen(false)}>
          <PlayerBox onClick={(e) => e.stopPropagation()}>
            <Close onClick={() => setOpen(false)}>
              <FaTimes />
            </Close>

            <Iframe
              //src={`$https://www.youtube.com/embed/0_gi-Ub7Lh4?autoplay=1`}
              src={`https://www.youtube.com/embed/0_gi-Ub7Lh4?autoplay=1&mute=1&playsinline=1`}
              title={title}
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </PlayerBox>
        </Modal>
      )}
    </>
  );
}
